<template>
    <d2-container>
        <h2>撬装受油记录</h2>
        <el-form ref="elForm" size="medium" label-width="100px">
            <el-row>
                <el-form-item label="撬装设备编码" prop="dd">
                    <el-input v-model="listQuery.oilEdequipmentCode" placeholder="撬装设备编码" clearable
                        :style="{ width: '763px' }"></el-input>
                </el-form-item>
            </el-row>
            <el-form-item size="large">
                <el-button size="small" class="filter-item" type="primary" icon="search"
                    @click="handleFilter">查询</el-button>
                <el-button @click="resetForm">重置</el-button>
            </el-form-item>
        </el-form>


        <!--表格-->
        <el-button size="small" class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary"
            icon="edit">添加受油报送</el-button>
        <el-button size="small" class="filter-item" style="margin-left: 10px;" @click="exportData('b', '撬装受油记录.csv')"
            type="primary" icon="edit">导出全部数据</el-button>
        <el-table :data="list" v-loading.body="listLoading" size="small" stripe highlight-current-row style="width: 100%">
            <el-table-column prop="recordId" type="selection" width="55" label="序号">
            </el-table-column>
            <el-table-column prop="oilEdequipmentCode" label="撬装设备编码" width="180">
            </el-table-column>
            <el-table-column prop="entName" label="用油企业" width="180">
            </el-table-column>
            <el-table-column prop="addressStreetName" label="所在街镇" width="260">
            </el-table-column>
            <!-- <el-table-column
                    label="油品类型"
            >
                <template slot-scope="scope">{{ scope.row.oilType==1?'柴油':'汽油' }}</template>
            </el-table-column> -->
            <el-table-column prop="injectionVolume" label="进油量（L）">
            </el-table-column>
            <!--            <el-table-column-->
            <!--                    prop="injectionWeight"-->
            <!--                    label="重量"-->
            <!--            >-->
            <!--            </el-table-column>-->
            <!--<el-table-column-->
            <!--label="同步状态"-->
            <!--&gt;-->
            <!--<template slot-scope="scope">{{ statusFun(scope.row.dataType) }}</template>-->
            <!--</el-table-column>-->
            <el-table-column prop="injectionTime" label="注油时间" width="160">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="220">
                <template slot-scope="scope">
                    <el-button size="small" @click="handleClick(scope.row)">查看</el-button>
                    <el-button size="small" type="success" @click="handleUpdate(scope.row)">编辑</el-button>
                    <el-button size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--分页-->
        <template slot="footer">
            <div v-show="!listLoading" class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                    layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
            </div>
        </template>

        <!--新增-->
        <el-dialog width="900px" :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
            <oilInrecord-form @close="close()" @on-success="close(true)" :formId="formId" :key="formId"
                :preview="preview"></oilInrecord-form>
        </el-dialog>

    </d2-container>
</template>


<script>
import {
    page,
    addObj,
    getObj,
    delObj,
    putObj
} from '@/api/admin/sysOilEdequipmentInrecord/index';
import { mapGetters } from 'vuex';
import { exportCsv } from "../../../api/admin/sysOilEdequipment";
import oilInrecordForm from "../sysForm/oilInrecord_add";
export default {
    components: {
        oilInrecordForm
    },
    name: 'sysBaseMaterial',
    data() {
        return {
            dialogFormVisible: false,
            list: null,
            total: null,
            listLoading: true,
            listQuery: {
                page: 1,
                limit: 20,
                oilEdequipmentCode: null
            },
            dialogStatus: '',
            textMap: {
                view: '查看',
                update: '编辑',
                create: '添加受油报送'
            },
            formId: null,
            preview: false
        }
    },
    created() {
        this.getList();
    },
    computed: {
        ...mapGetters([
            'elements'
        ])
    },
    methods: {
        exportData(type, fileName) {
            exportCsv(type, fileName);
        },
        statusFun(status) {
            if (status == 1) {
                return "新增";
            } else if (status == 2) {
                return "修改";
            } else if (status == 3) {
                return "删除";
            }
            return "";
        },
        getList() {
            this.listLoading = true;
            page(this.listQuery).then(response => {
                this.list = response.rows;
                this.total = response.total;
                this.listLoading = false;
            })
        },
        handleFilter() {
            this.getList();
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        handleCreate() {
            this.resetTemp();
            this.dialogStatus = 'create';
            this.dialogFormVisible = true;
            this.preview = false;
        },
        handleClick(row) {
            console.log(row);
            this.formId = row.recordId;
            this.dialogFormVisible = true;
            this.preview = true;
            this.dialogStatus = 'view';
        }, handleUpdate(row) {
            console.log(row);
            this.formId = row.recordId;
            this.dialogFormVisible = true;
            this.preview = false;
            this.dialogStatus = 'update';
        },
        handleDelete(row) {
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    delObj(row.recordId)
                        .then(() => {
                            this.$notify({
                                title: '成功',
                                message: '删除成功',
                                type: 'success',
                                duration: 2000
                            });
                            const index = this.list.indexOf(row);
                            this.list.splice(index, 1);
                        });
                });
        },
        create(formName) {
            const set = this.$refs;
            set[formName].validate(valid => {
                if (valid) {
                    addObj(this.form)
                        .then(() => {
                            this.dialogFormVisible = false;
                            this.getList();
                            this.$notify({
                                title: '成功',
                                message: '创建成功',
                                type: 'success',
                                duration: 2000
                            });
                        })
                } else {
                    return false;
                }
            });
        },
        close(flag) {
            this.dialogFormVisible = false;
            if (flag) {
                this.getList();
            }
        },
        cancel(formName) {
            this.dialogFormVisible = false;
            const set = this.$refs;
            set[formName].resetFields();
        },
        update(formName) {
            const set = this.$refs;
            set[formName].validate(valid => {
                if (valid) {
                    this.dialogFormVisible = false;
                    this.form.password = undefined;
                    putObj(this.form.id, this.form).then(() => {
                        this.dialogFormVisible = false;
                        this.getList();
                        this.$notify({
                            title: '成功',
                            message: '创建成功',
                            type: 'success',
                            duration: 2000
                        });
                    });
                } else {
                    return false;
                }
            });
        },
        resetTemp() {
            this.formId = null;
            this.form = {
                recordId: null,
                materialName: null,
                explainText: null,
                materialType: null,
                formType: null,
                sort: null,
            };
        },
        resetForm() {
            this.listQuery = {
                page: 1,
                limit: 20,
                materialName: null,
            }
        }
    }
}
</script>

